import { render } from "./tariff_rates_edit_tab.html?vue&type=template&id=c030760a&external"
import script from "./tariff_rates_edit_tab.js?vue&type=script&lang=js&external"
export * from "./tariff_rates_edit_tab.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__